import Icon from "@ant-design/icons";
import classNames from "classnames";
import React from "react";

export default function LoadingIcon({ className }: { className?: string }) {
  return (
    <Icon
      spin
      className={classNames("ac-icon", className)}
      component={IconSvg}
    />
  );
}

const IconSvg = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg height="1em" width="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 4.75C12.75 4.33579 12.4142 4 12 4C11.5858 4 11.25 4.33579 11.25 4.75V6.25C11.25 6.66421 11.5858 7 12 7C12.4142 7 12.75 6.66421 12.75 6.25V4.75ZM17.6569 7.40381C17.9498 7.11092 17.9498 6.63605 17.6569 6.34315C17.3641 6.05025 16.8892 6.05024 16.5963 6.34313L15.5356 7.40379C15.2427 7.69668 15.2427 8.17155 15.5356 8.46445C15.8285 8.75735 16.3033 8.75736 16.5962 8.46447L17.6569 7.40381ZM17 12C17 11.5858 17.3358 11.25 17.75 11.25H19.25C19.6642 11.25 20 11.5858 20 12C20 12.4142 19.6642 12.75 19.25 12.75H17.75C17.3358 12.75 17 12.4142 17 12ZM16.5962 15.5355C16.3033 15.2427 15.8284 15.2427 15.5355 15.5356C15.2427 15.8285 15.2427 16.3034 15.5356 16.5963L16.5963 17.6569C16.8892 17.9497 17.3641 17.9497 17.657 17.6568C17.9498 17.3639 17.9498 16.889 17.6569 16.5961L16.5962 15.5355ZM12 17C12.4142 17 12.75 17.3358 12.75 17.75V19.25C12.75 19.6642 12.4142 20 12 20C11.5858 20 11.25 19.6642 11.25 19.25V17.75C11.25 17.3358 11.5858 17 12 17ZM8.46452 16.5962C8.75742 16.3034 8.75743 15.8285 8.46455 15.5356C8.17166 15.2427 7.69679 15.2427 7.40389 15.5356L6.34323 16.5962C6.05033 16.889 6.05031 17.3639 6.3432 17.6568C6.63608 17.9497 7.11096 17.9497 7.40386 17.6568L8.46452 16.5962ZM4 12C4 11.5858 4.33579 11.25 4.75 11.25H6.25C6.66421 11.25 7 11.5858 7 12C7 12.4142 6.66421 12.75 6.25 12.75H4.75C4.33579 12.75 4 12.4142 4 12ZM7.40387 6.34314C7.11098 6.05025 6.63611 6.05025 6.34321 6.34314C6.05032 6.63603 6.05032 7.11091 6.34321 7.4038L7.40387 8.46446C7.69677 8.75735 8.17164 8.75735 8.46453 8.46446C8.75743 8.17157 8.75743 7.69669 8.46453 7.4038L7.40387 6.34314Z"
        fill="currentColor"
      />
    </svg>
  );
};
